module.exports = __webpack_public_path__ + "img/flags/LU.dd87418.png";